export default "__VITE_ASSET__DqMmUz8S__"